import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js';
import { BrowserRouter } from 'react-router-dom';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

(async () => {

  //Stripe
  const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);
  const backendUrl = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '');
  console.log('Fetching stripe secret from:', `${backendUrl}/stripe_secret`);
  console.log('API Key:', process.env.REACT_APP_API_KEY ? 'Present' : 'Missing');
  const response = await fetch(`${backendUrl}/stripe_secret`,
                                     {
                                     method: 'POST', 
                                     credentials: 'include', 
                                     headers: {
                                        'Content-Type': 'application/json',
                                        'X-API-Key': process.env.REACT_APP_API_KEY || ''
                                     }
                                 })
    .then(r => {
      console.log('Response status:', r.status);
      if (!r.ok) {
        throw new Error(`HTTP error! status: ${r.status}`);
      }
      return r.json();
    })
    .catch((err) => {
      console.error('Error fetching stripe secret: ', err);
      return {}; // Return empty object to prevent destructuring error
    });
  
  const clientSecret = response?.clientSecret;
  
  // Create context value to pass stripe availability status
  window.stripeClientSecret = clientSecret;
  
  if (!clientSecret) {
    console.error('Failed to get Stripe client secret');
    // Still render with Elements wrapper but without options
    // This prevents the useStripe error but components need to handle the missing secret
    ReactDOM.render(
      <React.StrictMode>
        <BrowserRouter>
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        </BrowserRouter>
      </React.StrictMode>,
      document.getElementById("root")
    );
  } else {
    const stripeOptions = {clientSecret: clientSecret};
    
    ReactDOM.render(
      <React.StrictMode>
        <BrowserRouter>
          <Elements stripe={stripePromise} options={stripeOptions}>
            <App />
          </Elements>
        </BrowserRouter>
      </React.StrictMode>,
      document.getElementById("root")
    );
  }
})()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
